// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guards-container {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-top: 8vh;
}

.guards-title {
  display: flex;
  width: 100vw;
  justify-content: center;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  margin-top: 5rem;
  margin-bottom: 5rem;
  font-style: italic;
  align-items: center;
}

.guard-image {
  display: block;
  margin-right: auto;
  margin-left: auto;
  min-width: 40vw;
  max-width: 50vw;
  height: auto;
  border-radius: 15px;
  margin-bottom: 1rem;
}

.guards-container p {
  font-size: 1.25rem;
  margin-right: 5vw;
  margin-left: 5vw;
  text-indent: 2.5rem;
  line-height: 1.6;
}

.guards-container h2,
.guards-container h3 {
  text-align: center;
  margin-top: 2rem;
}

.guards-container .landing-quote p {
  font-size: 1.75rem;
  text-align: center;
}

.guards-text,
.reachout {
  text-align: left;
  text-indent: 2rem;
}

.blue-text {
  color: #247a97;
  margin-bottom: 1.5rem;
}

.line-container {
  text-indent: 0;
}

.question-wrapper {
  margin-bottom: 10px;
}

.question {
  display: block;
  cursor: pointer;
  background-color: #f7f7f7;
  padding: 20px 50px 20px 25px;
  border: 1px solid #ddd;
  border-radius: 15px;
  margin: 0 5vw 0 5vw;
  font-size: 1.5rem;
  line-height: 1.5rem;
  font-weight: 800;

  &:hover {
    color: #ffffff;
    background-color: #247a97;
  }
}

.answer {
  padding: 5px 15px;
  border: 1px solid #ddd;
  border-top: none;
  margin-bottom: 2rem;
  font-size: 1.5rem;
  line-height: 1.7rem;
  margin-block-start: 1.5rem;
  margin-block-end: 1.5rem;
  margin-inline-start: 10vw;
  margin-inline-end: 10vw;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.gutter-guards-faq {
  font-family: Arial, sans-serif;
  font-size: 1.5rem;
  line-height: 1.7;
  text-align: left;
  text-indent: 1rem;
  margin-bottom: 2rem;
}

/* Responsive Design */
@media (max-width: 770px),
  screen and (max-width: 922px),
  screen and (max-width: 1215px) {
  .guards-container p,
  .guards-container h2,
  .guards-container h3,
  .line-container {
    font-size: 1.5rem;
    margin-right: 3vw;
    margin-left: 3vw;
    text-indent: 1rem;
  }

  .question {
    font-size: 1.5rem;
  }

  .answer {
    font-size: 1.5rem;
  }
}

@media (max-width: 600px) {
  .guards-container p,
  .guards-container h2,
  .guards-container h3,
  .line-container {
    font-size: 1.25rem;
  }

  .question {
    font-size: 1.35rem;
  }

  .answer {
    font-size: 1.35rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/GutterGuards.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;;EAEhB;IACE,cAAc;IACd,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB;sCACoC;EACpC,qBAAqB;EACrB,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;;;EAGE;;;;IAIE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;;;IAIE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".guards-container {\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  margin-top: 8vh;\n}\n\n.guards-title {\n  display: flex;\n  width: 100vw;\n  justify-content: center;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n  font-style: italic;\n  align-items: center;\n}\n\n.guard-image {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n  min-width: 40vw;\n  max-width: 50vw;\n  height: auto;\n  border-radius: 15px;\n  margin-bottom: 1rem;\n}\n\n.guards-container p {\n  font-size: 1.25rem;\n  margin-right: 5vw;\n  margin-left: 5vw;\n  text-indent: 2.5rem;\n  line-height: 1.6;\n}\n\n.guards-container h2,\n.guards-container h3 {\n  text-align: center;\n  margin-top: 2rem;\n}\n\n.guards-container .landing-quote p {\n  font-size: 1.75rem;\n  text-align: center;\n}\n\n.guards-text,\n.reachout {\n  text-align: left;\n  text-indent: 2rem;\n}\n\n.blue-text {\n  color: #247a97;\n  margin-bottom: 1.5rem;\n}\n\n.line-container {\n  text-indent: 0;\n}\n\n.question-wrapper {\n  margin-bottom: 10px;\n}\n\n.question {\n  display: block;\n  cursor: pointer;\n  background-color: #f7f7f7;\n  padding: 20px 50px 20px 25px;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n  margin: 0 5vw 0 5vw;\n  font-size: 1.5rem;\n  line-height: 1.5rem;\n  font-weight: 800;\n\n  &:hover {\n    color: #ffffff;\n    background-color: #247a97;\n  }\n}\n\n.answer {\n  padding: 5px 15px;\n  border: 1px solid #ddd;\n  border-top: none;\n  margin-bottom: 2rem;\n  font-size: 1.5rem;\n  line-height: 1.7rem;\n  margin-block-start: 1.5rem;\n  margin-block-end: 1.5rem;\n  margin-inline-start: 10vw;\n  margin-inline-end: 10vw;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  border-radius: 0.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.gutter-guards-faq {\n  font-family: Arial, sans-serif;\n  font-size: 1.5rem;\n  line-height: 1.7;\n  text-align: left;\n  text-indent: 1rem;\n  margin-bottom: 2rem;\n}\n\n/* Responsive Design */\n@media (max-width: 770px),\n  screen and (max-width: 922px),\n  screen and (max-width: 1215px) {\n  .guards-container p,\n  .guards-container h2,\n  .guards-container h3,\n  .line-container {\n    font-size: 1.5rem;\n    margin-right: 3vw;\n    margin-left: 3vw;\n    text-indent: 1rem;\n  }\n\n  .question {\n    font-size: 1.5rem;\n  }\n\n  .answer {\n    font-size: 1.5rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .guards-container p,\n  .guards-container h2,\n  .guards-container h3,\n  .line-container {\n    font-size: 1.25rem;\n  }\n\n  .question {\n    font-size: 1.35rem;\n  }\n\n  .answer {\n    font-size: 1.35rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
